import React, { Fragment } from "react";

import {
  ButtonBase,
  Card,
  CardContent,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { AALogo, BSMLogo } from "./components";
import { useTealium } from "@hubcapp/context";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    background: theme.palette.background.dark,
  },
  title: {
    fontSize: "14px",
    lineHeight: "22px",
    marginBottom: "24px",
    textAlign: "center",
  },
  logo: {
    margin: `${theme.spacing(2)}px 0 0 ${theme.spacing(2)}px`,
  },
  main: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4, 2, 4, 2),
  },
  card: {
    overflow: "visible",
    display: "flex",
    position: "relative",
    marginBottom: "0",
    [theme.breakpoints.down("md")]: {
      marginBottom: "24px",
    },
    "& > *": {
      flexGrow: 1,
      flexBasis: "50%",
      width: "50%",
    },
  },
  content: {
    alignContent: "center",
    display: "flex",
    padding: "0 !important",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      flexDirection: "column",
    },
    "& > button": {
      padding: "190px",

      [theme.breakpoints.down("md")]: {
        padding: "68px",
      },
    },
  },
  wapper: {
    display: "flex",
    flexDirection: "row",
    "& > div:first-child": {
      marginRight: "24px",
    },
    [theme.breakpoints.down("md")]: {
      "& > div:first-child": {
        marginRight: "0",
      },
      flexDirection: "column",
    },
  },
}));

type Brand = "aa" | "bsm";

export default function BrandSelector() {
  const classes = useStyles();
  const history = useHistory();
  const { trackEvent } = useTealium();

  const handleClick = (brand: Brand) => {
    trackEvent({
      eventCategory: "Brand Select",
      eventAction: "Interaction",
      eventLabel: brand,
    });
    history.push(`/${brand}/sign-in`);
  };

  return (
    <Fragment>
      <Typography className={classes.title}>
        Select your franchise brand
      </Typography>
      <div className={classes.wapper}>
        <Card className={classes.card}>
          <CardContent className={classes.content}>
            <ButtonBase
              onClick={() => handleClick("aa")}
              data-test="brand-select-aa"
            >
              <AALogo />
            </ButtonBase>
          </CardContent>
        </Card>
        <Card className={classes.card}>
          <CardContent className={classes.content}>
            <ButtonBase
              onClick={() => handleClick("bsm")}
              data-test="brand-select-bsm"
            >
              <BSMLogo />
            </ButtonBase>
          </CardContent>
        </Card>
      </div>
    </Fragment>
  );
}
